import { useAppSelector } from '../store';

const useIsOwnAuthorPageMaterial = (material?: Material): boolean => {
    const currentAuthorPage = useAppSelector((state: RootState) => state.author as Author);

    const authorPageId = currentAuthorPage?.id;
    const materialAuthorId = material?.author?.id;

    return Boolean(authorPageId && materialAuthorId && Number(authorPageId) === Number(materialAuthorId));
};

export default useIsOwnAuthorPageMaterial;
